import * as React from "react";
const ButtonRecordIcon = (props) => (
  <svg
    width={18}
    height={19}
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={9} cy={9.5} r={9} fill="white" />
  </svg>
);
export default ButtonRecordIcon;
